import { isLocaleSol } from '@packages/locale/utils/market.ts'

export const isSol: () => boolean = () => {
  const { public: { locale } } = useRuntimeConfig()
  return isLocaleSol(locale)
}
